import { type ReactNode } from "react";

import { useGridContainerStickyHeight } from "commonComponents/utilities/Grid/useGridContainerStickyHeight";

import "./GridContainerMapList.less";

export function GridContainerMapList({ children }: { children: ReactNode }) {
    const ref = useGridContainerStickyHeight("--grid-container-maplist-height");
    return (
        <div ref={ref} className="GridContainerMapListContainer">
            <div className="GridContainerMapList">{children}</div>
        </div>
    );
}
